export function emailAvailabilityQueryDefinition(email) {
  return {
    url: `/api/me/validate_email.json`,
    enabled: Boolean(email),
    params: {
      email
    }
  };
}
